import { createReducer } from 'reduxsauce';
import { Types } from './types';
import { INITIAL_STATE } from './initialState';

export const bioStart = state => ({
  ...state,
  isLoading: true,
  error: null,
});

export const bioSuccess = (state, { data }) => ({
  ...state,
  data,
  isLoading: false,
});

export const bioError = (state, { error }) => ({
  ...state,
  error,
  isLoading: false,
});

export const bioCleanUp = () => INITIAL_STATE;

export const HANDLERS = {
  [Types.BIO_START]: bioStart,
  [Types.BIO_SUCCESS]: bioSuccess,
  [Types.BIO_ERROR]: bioError,
  [Types.BIO_CLEAN_UP]: bioCleanUp,
};

export default createReducer(INITIAL_STATE, HANDLERS);
